import React from "react";
import { useLocation, Link } from "react-router-dom";
import { getRouteName } from "functions/getMeta";
import routes from "configs/routes";

import Features from "./Features";

//import default_image from 'assets/images/csango10-13kerulet-elado-lakasok.webp';
import default_image from 'assets/images/csango10-13kerulet-elado-lakasok-4.webp';
import clg from "functions/log";

const PageHeader = ( props ) => {

    const location = useLocation();

    const backgroundImage = ( props.backgroundImage ? props.backgroundImage : default_image );
    const backgroundPosition = ( props.backgroundPosition ? props.backgroundPosition : "center center" );
    const featuresEnabled = ( props.featuresEnabled ? props.featuresEnabled : false );
    const featuresData = ( props.featuresData ? props.featuresData : null );
    const featureItemClass = ( props.featureItemClass ? props.featureItemClass : null );

    const title = ( props.title ? props.title : getRouteName( location.pathname ) );
    const subtitle = ( props.subtitle ? props.subtitle : null );
    const featuresRowClass = (props.featuresRowClass ? " " + props.featuresRowClass : null);

    const style = {
        backgroundImage : `url(${backgroundImage})`,
        backgroundSize : "cover",
        backgroundPosition : backgroundPosition,
        backgroundRepeat : "no-repeat",
    }

    return (
        <>
        <div className="container-fluid page-header overlay" style={ style }>
            <div className="row">
                <div className={`col-12 inner${subtitle ? " has-subtitle" : ""}`}>
                    <h1 className="title">
                        {title}
                    </h1>
                    {
                        subtitle && (
                            <div className="subtitle">
                                {subtitle}
                            </div>
                        )
                    }

                    

                    <div className="location">
                        <Link to={ routes.index } className="home">{ getRouteName( routes.index ) }</Link>
                        <i className="fas fa-chevron-right"></i>
                        <div className="active">{ getRouteName( location.pathname ) }</div>
                    </div>
                </div>
            </div>
        </div>
        {(location.pathname.match(/\//g) || []).length === 1 && (
            <div className={"nav-alert-static mt-2"}>Személyes találkozó előtt időpontegyeztetés szükséges!</div>
        )}

        {
            (featuresEnabled && featuresData) && (
                <Features rowClass={featuresRowClass} parentClass="apartment-single-header-features" featureItemClass={ featureItemClass ? featureItemClass : "col-lg-3 col-6 single-feature" } boxFeatureClass="apartment-data" data={ featuresData } />
            )
        }
        </>
    );
}

export default PageHeader;